import {ExamModelV1} from 'resources/GeneratedModels/Exam/ExamModel.v1';

import {examExtensions} from './exam.extensions';

ExamModelV1.extend(examExtensions);

export {ExamModelV1};
